module.exports = __webpack_public_path__ + "img/04.c2596486.jpg";